export default __webpack_public_path__ + "static/2.5.2/media/contactImage.e15dd3a5.svg";